import {
  Box,
  Breadcrumbs,
  Link,
  TablePagination,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import { useEffect, useMemo } from "react";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import FormContainer from "../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { CustomFooter } from "./components/CustomFooter";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";
import { DropDownCliente } from "../../../../../common/components/dropdown_cliente";
import { FormSelectInput } from "../../../../../common/components/masked_inputs/react_forms/form_select_input";
import { DiarioObrasEfetivoLista } from "../../../domain/models/diario_obras_efetivo_lista";
import { GenerateEfetivoColumns } from "./columns/qualidade_efetivo";
import { GenerateEquipamentoColumns } from "./columns/qualidade_equipamento";
import { DiarioObrasEquipamentoLista } from "../../../domain/models/diario_obras_equipamento_lista";
import { DiarioObrasAtividadesLista } from "../../../domain/models/diario_obras_atividades_lista";
import { GenerateAtividadesColumns } from "./columns/qualidade_atividades";
import { DiarioObrasParalisacoesLista } from "../../../domain/models/diario_obras_paralisacoes_lista";
import { GenerateParalisacoesColumns } from "./columns/qualidade_paralisacoes";
import { DiarioObrasImagem } from "../../../domain/models/diario_obras_imagens_lista";

import { useDiarioObraCadastroViewModel } from "../../viewModels/diario_obra_cadastro_view_model";
import CommonConstants from "../../../../../common/constants";
import { GenerateImagensColumns } from "./columns/qualidade_imagens";
import BottomBar from "../../../../../common/components/bottom_bar";
import { EfetivoModal } from "./components/efetivo_modal";
import { DiarioObrasEfetivoForm } from "../../schemas/DiarioObrasEfetivo/diario_obras_efetivo";
import { DiarioObrasEquipamentoForm } from "../../schemas/DiarioObrasEquipamento/diario_obras_equipamento";
import { EquipamentoModal } from "./components/equipamento_modal";
import { AtividadesModal } from "./components/atividades_modal";
import { DiarioObrasAtividadesForm } from "../../schemas/DiarioObrasAtividades/diario_obras_atividades";
import { ParalisacoesModal } from "./components/paralisacoes_modal";
import { DiarioObrasParalisacoesForm } from "../../schemas/DiarioObrasParalisacoes/diario_obras_paralisacoes";
import { ImagensModal } from "./components/imagens_modal";
import { DiarioObrasImagensForm } from "../../schemas/DiarioObrasImagens/diario_obras_imagens";
import { BackButton } from "../../../../../common/components/back_button";
import { isValidId } from "../../../../../common/utils/utils";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { EfetivoFuncionariosModal } from "./components/efetivo_funcionarios_modal";
import { FormTimeRangePickerInput } from "../../../../../common/components/default_time_range_picker_input";

export const DiarioObra_Cadastro = () => {
  const viewModel = useDiarioObraCadastroViewModel();

  const tipoMaoDeObraValue = viewModel.hookFormEfetivo.watch("Tipo");
  const tipoMaoDeObraAValue =
    viewModel.hookFormAtividades.watch("TipoMaoDeObra");

  useEffect(() => {
    if (Number(tipoMaoDeObraValue) === 0) {
      viewModel.hookFormEfetivo.setValue("IdFornecedor", null);
    }
    if (Number(tipoMaoDeObraAValue) === 0) {
      viewModel.hookFormAtividades.setValue("IdFornecedor", null);
    }
  }, [
    tipoMaoDeObraAValue,
    tipoMaoDeObraValue,
    viewModel.hookFormAtividades,
    viewModel.hookFormEfetivo,
  ]);

  const QualidadeEfetivoListaColumns = useMemo(() => {
    return GenerateEfetivoColumns({
      onActionEditar: viewModel.handleEdicaoEfetivoOpenState,
      onActionDeletar: viewModel.handleDeleteDiarioEfetivoModalOpenState,
      read: viewModel.read,
      onActionModal: viewModel.handleEfetivoFuncionarioOpenState,
    });
  }, [viewModel]);

  const QualidadeEquipamentoistaColumns = useMemo(() => {
    return GenerateEquipamentoColumns({
      onActionEditar: viewModel.handleEdicaoEquipamentoOpenState,
      onActionDeletar: viewModel.handleDeleteDiarioEquipamentoModalOpenState,
      read: viewModel.read,
    });
  }, [viewModel]);

  const QualidadepaginationAtividadesListaColumns = useMemo(() => {
    return GenerateAtividadesColumns({
      onActionEditar: viewModel.handleEdicaoAtividadesOpenState,
      onActionDeletar: viewModel.handleDeleteDiarioAtividadesModalOpenState,
      read: viewModel.read,
    });
  }, [viewModel]);

  const QualidadepaginationParalisacoesListaColumns = useMemo(() => {
    return GenerateParalisacoesColumns({
      onActionEditar: viewModel.handleEdicaoParalisacoesOpenState,
      onActionDeletar: viewModel.handleDeleteDiarioParalisacoesModalOpenState,
      read: viewModel.read,
    });
  }, [viewModel]);

  const QualidadepaginationImagensListaColumns = useMemo(() => {
    return GenerateImagensColumns({
      onActionEditar: viewModel.handleEdicaoImagensOpenState,
      onActionDeletar: viewModel.handleDeleteDiarioImagensModalOpenState,
      onActionDownload: viewModel.handleDownloadImagem,
      read: viewModel.read,
    });
  }, [viewModel]);
  const statusValue = viewModel.hookForm.watch("StatusNome");
  const nroDiarioValue = viewModel.hookForm.watch("NroDiario");

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          leftSlot={
            <div className="flex flex-row items-center gap-6 bg-white px-5 py-2 rounded-lg border border-gray-200 shadow-sm ml-6">
              <div className="flex flex-col">
                <span className="text-[10px] text-gray-500 uppercase font-bold tracking-wider">
                  Status
                </span>
                <div className="flex items-center gap-2 mt-0.5">
                  <span
                    className={`w-2 h-2 rounded-full ${statusValue === "Em Aberto" ? "bg-yellow-500" : "bg-green-500"}`}
                  ></span>
                  <span className="text-sm font-semibold text-gray-800">
                    {statusValue || "-"}
                  </span>
                </div>
              </div>
              <div className="w-px h-8 bg-gray-200"></div>
              <div className="flex flex-col">
                <span className="text-[10px] text-gray-500 uppercase font-bold tracking-wider">
                  Nº do Documento
                </span>
                <span className="text-sm font-bold text-primary-green mt-0.5">
                  {nroDiarioValue || "-"}
                </span>
              </div>
            </div>
          }
          rightSlot={
            <div className="mr-6">
              <BackButton onClick={viewModel.handleVoltarDiario} />
            </div>
          }
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Diário de Obras
            </Link>
            <Typography className="text-primary-green">
              Diário de Obras Lista
            </Typography>
            <Typography className="text-primary-green">
              Cadastro Diário de Obras
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Cadastro Diário de Obras
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
            {/* INFORMAÇÕES GERAIS */}
            <FormContainer title={"Informações Gerais"} arrangement="fullRow">
              <Box
                className="flex flex-col w-full"
                sx={{
                  "& .MuiAutocomplete-popper": {
                    zIndex: "99999 !important",
                  },
                }}
              >
                <div className="flex items-center justify-start py-2">
                  <FormRadioGroupInput
                    name="Status"
                    label="Status"
                    readOnly={viewModel.saving}
                    options={[
                      { id: 0, label: "Em elaboração" },
                      { id: 2, label: "Liberado para aprovação" },
                      { id: 1, label: "Aprovado" },
                    ]}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                  <FormDatePickerInput
                    name="DataCadastro"
                    label="Data Cadastro"
                    required={true}
                    readOnly={viewModel.saving || viewModel.read}
                    reactHookForm={viewModel.hookForm}
                  />

                  <DropDownFuncionario
                    name="IdFuncionarioResponsavel"
                    readOnly={viewModel.saving || viewModel.read}
                    reactHookForm={viewModel.hookForm}
                    label="Responsável"
                  />

                  <DropDownFuncionario
                    name="IdFuncionarioAprovador"
                    readOnly={viewModel.saving || viewModel.read}
                    reactHookForm={viewModel.hookForm}
                    label="Aprovado por:"
                  />

                  <div className="flex items-center justify-start py-2">
                    <FormRadioGroupInput
                      name="DiaPraticavel"
                      label="Dia Praticável"
                      readOnly={viewModel.saving || viewModel.read}
                      options={[
                        { id: 0, label: "Não" },
                        { id: 1, label: "Sim" },
                        { id: 2, label: "Parcial" },
                      ]}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>

                  <DropDownCentroCusto
                    name="IdCentroCusto"
                    label="Centro Custo"
                    required={true}
                    readOnly={viewModel.saving || viewModel.read}
                    reactHookForm={viewModel.hookForm}
                  />

                  <DropDownCliente
                    name="IdCliente"
                    label="Cliente"
                    required={false}
                    readOnly={viewModel.saving || viewModel.read}
                    reactHookForm={viewModel.hookForm}
                  />

                  <div className="w-full md:col-span-full grid grid-cols-1 md:grid-cols-5 gap-4">
                    <div className="w-full md:col-span-1">
                      <FormSelectInput
                        name="CondicaoTempo"
                        label="Condição Tempo"
                        readOnly={viewModel.saving || viewModel.read}
                        required={true}
                        options={[
                          { id: "B", label: "Bom" },
                          { id: "N", label: "Nublado" },
                          { id: "C", label: "Chuvoso" },
                        ]}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-full md:col-span-2">
                      <FormTimeRangePickerInput
                        startName="HorarioTrabalhoDe"
                        endName="HorarioTrabalhoAte"
                        label="Horário de trabalho "
                        required={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-full md:col-span-2">
                      <FormTimeRangePickerInput
                        startName="HorarioAlmocoDe"
                        endName="HorarioAlmocoAte"
                        label="Horário de almoço "
                        required={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </div>
                </div>
              </Box>
            </FormContainer>

            {/* SEÇÃO EFETIVO */}
            <br />
            {viewModel.read === false ? (
              <span>Inserir o efetivo</span>
            ) : (
              <span>Tabela de efetivos</span>
            )}
            {viewModel.read === false ? (
              <div className="w-40 mt-4 mb-4">
                <PrimaryButton
                  type="button"
                  onClick={viewModel.handleEfeivo}
                  buttonColor={"primary-green"}
                >
                  Novo
                </PrimaryButton>
              </div>
            ) : (
              <></>
            )}
            {viewModel.diarioObrasListaEfetivo.length > 0 ? (
              <>
                <StyledDataGrid
                  tableName="Diario Obras Efetivo"
                  disableColumnMenu={false}
                  getRowId={(row: DiarioObrasEfetivoLista) =>
                    row.IdDiarioObrasEfetivo
                  }
                  autoHeight={true}
                  textSize="pequeno"
                  getRowHeight={() => "auto"}
                  columns={QualidadeEfetivoListaColumns}
                  loading={viewModel.loadingEfetivo}
                  rows={viewModel.diarioObrasListaEfetivo}
                  rowCount={viewModel.paginationEfetivo.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  slots={{
                    footer: () => (
                      <CustomFooter
                        totalGeral={viewModel.totaisEfetivo.totalGeral}
                        totalPropria={viewModel.totaisEfetivo.totalPropria}
                        totalTerceirizada={
                          viewModel.totaisEfetivo.totalTerceirizada
                        }
                      />
                    ),
                  }}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationEfetivo.page - 1,
                    pageSize: viewModel.paginationEfetivo.rowsPerPage,
                  }}
                />
                <TablePagination
                  component="div"
                  count={viewModel.paginationEfetivo.totalItems}
                  page={viewModel.paginationEfetivo.page - 1}
                  onPageChange={(_, p) => viewModel.handleTableEfetivoChange(p)}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={viewModel.paginationEfetivo.rowsPerPage}
                  onRowsPerPageChange={(e) =>
                    viewModel.handleRowsPerTableEfetivoChange(
                      parseInt(e.target.value),
                    )
                  }
                />
              </>
            ) : (
              <></>
            )}

            {/* SEÇÃO EQUIPAMENTO */}
            <br />
            {viewModel.read === false ? (
              <span>Inserir o equipamento</span>
            ) : (
              <span>Tabela de equipamentos</span>
            )}

            {viewModel.read === false ? (
              <div className="w-40 mt-4  mb-4">
                <PrimaryButton
                  type="button"
                  onClick={viewModel.handleEquipamento}
                  buttonColor={"primary-green"}
                >
                  Novo
                </PrimaryButton>
              </div>
            ) : (
              <></>
            )}

            {viewModel.diarioObrasListEquipamento.length > 0 ? (
              <>
                <StyledDataGrid
                  tableName="Diario Obras Equipamento"
                  disableColumnMenu={false}
                  getRowId={(row: DiarioObrasEquipamentoLista) =>
                    row.IdDiarioObrasEquipamento
                  }
                  columns={QualidadeEquipamentoistaColumns}
                  loading={viewModel.loadingEquipamento}
                  rows={viewModel.diarioObrasListEquipamento}
                  rowCount={viewModel.paginationEquipamento.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  autoHeight={true}
                  textSize="pequeno"
                  getRowHeight={() => "auto"}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationEquipamento.page - 1,
                    pageSize: viewModel.paginationEquipamento.rowsPerPage,
                  }}
                />
                <TablePagination
                  component="div"
                  count={viewModel.paginationEquipamento.totalItems}
                  page={viewModel.paginationEquipamento.page - 1}
                  onPageChange={(_, p) => viewModel.handleTableEquipaChange(p)}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={viewModel.paginationEquipamento.rowsPerPage}
                  onRowsPerPageChange={(e) =>
                    viewModel.handleRowsPerTableEquipaChange(
                      parseInt(e.target.value),
                    )
                  }
                />
              </>
            ) : (
              <></>
            )}

            {/* SEÇÃO ATIVIDADES */}
            <br />
            {viewModel.read === false ? (
              <span>Inserir o atividades</span>
            ) : (
              <span>Tabela de atividades</span>
            )}

            {viewModel.read === false ? (
              <div className="w-40 mt-4  mb-4">
                <PrimaryButton
                  type="button"
                  onClick={viewModel.handleAtividades}
                  buttonColor={"primary-green"}
                >
                  Novo
                </PrimaryButton>
              </div>
            ) : null}

            {viewModel.diarioObrasListAtividades.length > 0 ? (
              <>
                <StyledDataGrid
                  tableName="Diario Obras Atividades"
                  disableColumnMenu={false}
                  getRowId={(row: DiarioObrasAtividadesLista) =>
                    row.IdDiarioObrasAtividades
                  }
                  columns={QualidadepaginationAtividadesListaColumns}
                  loading={viewModel.loadingAtividades}
                  rows={viewModel.diarioObrasListAtividades}
                  rowCount={viewModel.paginationAtividades.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  autoHeight={true}
                  textSize="pequeno"
                  getRowHeight={() => "auto"}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationAtividades.page - 1,
                    pageSize: viewModel.paginationAtividades.rowsPerPage,
                  }}
                />
                <TablePagination
                  component="div"
                  count={viewModel.paginationAtividades.totalItems}
                  page={viewModel.paginationAtividades.page - 1}
                  onPageChange={(_, p) =>
                    viewModel.handleTableAtividadeChange(p)
                  }
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={viewModel.paginationAtividades.rowsPerPage}
                  onRowsPerPageChange={(e) =>
                    viewModel.handleRowsPerTableAtividadeChange(
                      parseInt(e.target.value),
                    )
                  }
                />
              </>
            ) : (
              <></>
            )}

            {/* SEÇÃO PARALISAÇÕES */}
            <br />
            {viewModel.read === false ? (
              <span>Inserir o paralisações</span>
            ) : (
              <span>Tabela de paralisações</span>
            )}

            {viewModel.read === false ? (
              <div className="w-40 mt-4  mb-4">
                <PrimaryButton
                  type="button"
                  onClick={viewModel.handleParalisacoes}
                  buttonColor={"primary-green"}
                >
                  Novo
                </PrimaryButton>
              </div>
            ) : null}

            {viewModel.diarioObrasListParalisacoes.length > 0 ? (
              <>
                <StyledDataGrid
                  tableName="Diario Obras Paralisacoes"
                  disableColumnMenu={false}
                  getRowId={(row: DiarioObrasParalisacoesLista) =>
                    row.IdDiarioObrasParalisacoes
                  }
                  columns={QualidadepaginationParalisacoesListaColumns}
                  loading={viewModel.loadingParalisacoes}
                  rows={viewModel.diarioObrasListParalisacoes}
                  rowCount={viewModel.paginationParalisacoes.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  autoHeight={true}
                  textSize="pequeno"
                  getRowHeight={() => "auto"}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationParalisacoes.page - 1,
                    pageSize: viewModel.paginationParalisacoes.rowsPerPage,
                  }}
                />
                <TablePagination
                  component="div"
                  count={viewModel.paginationParalisacoes.totalItems}
                  page={viewModel.paginationParalisacoes.page - 1}
                  onPageChange={(_, p) =>
                    viewModel.handleTableParalisacoesChange(p)
                  }
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={viewModel.paginationParalisacoes.rowsPerPage}
                  onRowsPerPageChange={(e) =>
                    viewModel.handleRowsPerTableParalisacoesChange(
                      parseInt(e.target.value),
                    )
                  }
                />
              </>
            ) : (
              <></>
            )}

            {/* SEÇÃO IMAGENS */}

            <br />
            {viewModel.read === false ? (
              <span>Inserir as imagens</span>
            ) : (
              <span>Tabela de imagens</span>
            )}

            {viewModel.read === false ? (
              <div className="w-40 mt-4  mb-4">
                <PrimaryButton
                  type="button"
                  onClick={viewModel.handleImagens}
                  buttonColor={"primary-green"}
                >
                  Novo
                </PrimaryButton>
              </div>
            ) : null}

            {viewModel.diarioObrasListImagens.length > 0 ? (
              <>
                <StyledDataGrid
                  tableName="Diario Obras Imagens"
                  disableColumnMenu={false}
                  getRowId={(row: DiarioObrasImagem) =>
                    row.IdDiarioObrasImagens
                  }
                  columns={QualidadepaginationImagensListaColumns}
                  loading={viewModel.loadingImagens}
                  rows={viewModel.diarioObrasListImagens}
                  rowCount={viewModel.paginationImagens.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  autoHeight={true}
                  textSize="pequeno"
                  getRowHeight={() => "auto"}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationImagens.page - 1,
                    pageSize: viewModel.paginationImagens.rowsPerPage,
                  }}
                />
                <TablePagination
                  component="div"
                  count={viewModel.paginationImagens.totalItems}
                  page={viewModel.paginationImagens.page - 1}
                  onPageChange={(_, p) => viewModel.handleTableImagensChange(p)}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={viewModel.paginationImagens.rowsPerPage}
                  onRowsPerPageChange={(e) =>
                    viewModel.handleRowsPerTableImagensChange(
                      parseInt(e.target.value),
                    )
                  }
                />
              </>
            ) : (
              <></>
            )}
            <div className="md:col-span-2">
              <DefaultFormInput
                name="Observacao"
                label="Ocorrências e Resumo do dia"
                readOnly={viewModel.saving || viewModel.read}
                multiline={true}
                rows={4}
                reactHookForm={viewModel.hookForm}
              />
            </div>
            <div className="mt-8">
              <span className="text-lg font-bold mb-4 block">Assinaturas</span>
              <div className="flex flex-col md:flex-row gap-8 w-full justify-start items-start">
                <div className="flex flex-col items-center gap-2">
                  <div className="w-[16rem] h-[12rem] border border-gray-300 bg-white p-2 flex justify-center items-center">
                    {viewModel.selectedDiarioObra?.AssinaturaCliente ? (
                      <img
                        src={`data:image/*;base64,${viewModel.selectedDiarioObra.AssinaturaCliente}`}
                        className="w-full h-full object-contain"
                        alt="Assinatura Cliente"
                      />
                    ) : (
                      <img
                        src={CommonConstants.assets.iso}
                        className="w-16 h-16 object-contain opacity-30"
                        alt="Sem assinatura"
                      />
                    )}
                  </div>
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    Cliente
                  </span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <div className="w-[16rem] h-[12rem] border border-gray-300 bg-white p-2 flex justify-center items-center">
                    {viewModel.selectedDiarioObra?.AssinaturaConstrutora ? (
                      <img
                        src={`data:image/*;base64,${viewModel.selectedDiarioObra.AssinaturaConstrutora}`}
                        className="w-full h-full object-contain"
                        alt="Assinatura Construtora"
                      />
                    ) : (
                      <img
                        src={CommonConstants.assets.iso}
                        className="w-16 h-16 object-contain opacity-30"
                        alt="Sem assinatura"
                      />
                    )}
                  </div>
                  <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                    Construtora
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {isValidId(viewModel.IdDiarioObras) && (
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}
                >
                  <span className="text-xs">Historico de alterações</span>
                </PrimaryButton>
              )}
            </div>
            {viewModel.read === false && (
              <div className="flex flex-row gap-4 ml-auto">
                <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                  <h1
                    className="text-sm text-black dark:text-white"
                    onClick={viewModel.handleVoltarDiario}
                  >
                    Cancelar
                  </h1>
                </div>
                <div className="w-[130px]">
                  {viewModel.saving ? (
                    <PrimaryButton>Salvando...</PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      onClick={viewModel.hookForm.handleSubmit(
                        viewModel.handleDiarioObraSubmit,
                      )}
                      startIcon={
                        <DynamicIcon
                          nameIcon="CheckRounded"
                          size={25}
                          className="text-white"
                        />
                      }
                    >
                      Salvar
                    </PrimaryButton>
                  )}
                </div>
              </div>
            )}
          </div>
        </BottomBar>
      </form>
      <EfetivoModal
        open={viewModel.openEfetivo}
        IdDiarioObras={viewModel.IdDiarioObras}
        saving={viewModel.saving}
        selectedEfetivo={
          (viewModel.selectedDiarioObraEfetivo ??
            null) as unknown as DiarioObrasEfetivoForm | null
        }
        onSubmit={viewModel.handleEfetivoSubmit}
        onClose={() => viewModel.setOpenEfetivo(false)}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        funcionarioDropdown={viewModel.funcionarioDropdown}
        funcionarioTerceirizadoDropdown={
          viewModel.funcionarioTerceirizadoDropdown
        }
        loadFuncionarioDropDown={viewModel.loadFuncionarioDropDown}
        loadFuncionarioTerceirizadoDropDown={
          viewModel.loadFuncionarioTerceirizadoDropDown
        }
      />
      <EfetivoFuncionariosModal
        open={viewModel.modalAberto}
        onClose={() => viewModel.setModalAberto(false)}
        idsFuncionarios={viewModel.linhaSelecionada?.ids || []}
        tipoMaoDeObra={viewModel.linhaSelecionada?.tipo ?? 0}
        funcionarioDropdown={viewModel.funcionarioDropdown}
        funcionarioTerceirizadoDropdown={
          viewModel.funcionarioTerceirizadoDropdown
        }
      />

      <EquipamentoModal
        open={viewModel.openEquipamento}
        IdDiarioObras={viewModel.IdDiarioObras}
        saving={viewModel.saving}
        selectedEquipamento={
          (viewModel.selectedDiarioObraEquipamento ??
            null) as unknown as DiarioObrasEquipamentoForm | null
        }
        onSubmit={viewModel.handleEquipamentoSubmit}
        onClose={() => viewModel.setOpenEquipamento(false)}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />

      <AtividadesModal
        open={viewModel.openAtividades}
        IdDiarioObras={viewModel.IdDiarioObras}
        saving={viewModel.saving}
        selectedAtividades={
          (viewModel.selectedDiarioObraAtividades ??
            null) as unknown as DiarioObrasAtividadesForm | null
        }
        onSubmit={viewModel.handleAtividadesSubmit}
        onClose={() => viewModel.setOpenAtividades(false)}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />
      <ParalisacoesModal
        open={viewModel.openParalisacoes}
        IdDiarioObras={viewModel.IdDiarioObras}
        saving={viewModel.saving}
        selectedParalisacoes={
          (viewModel.selectedDiarioObraParalisacoes ??
            null) as unknown as DiarioObrasParalisacoesForm | null
        }
        onSubmit={viewModel.handleParalisacoesSubmit}
        onClose={() => viewModel.setOpenParalisacoes(false)}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />
      <ImagensModal
        open={viewModel.openImagens}
        IdDiarioObras={viewModel.IdDiarioObras}
        saving={viewModel.saving}
        selectedImagens={
          (viewModel.selectedDiarioObraImagens ??
            null) as unknown as DiarioObrasImagensForm | null
        }
        onSubmit={viewModel.handleImagensSubmit}
        onClose={() => viewModel.setOpenImagens(false)}
        fileUploadUrl={viewModel.fileUploadUrl ?? ""}
        handleDeleteFileUpload={viewModel.handleDeleteFileUpload}
        handleStartFileUpload={viewModel.handleStartFileUpload}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />
      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
      {/* DIALOGS */}
      <DeleteDialog
        open={viewModel.diarioObraEfetivoDeleteModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeleteDiarioEfetivoModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaDiarioEfetivo}
      />
      <DeleteDialog
        open={viewModel.diarioObraEquipamentoDeleteModal}
        saving={viewModel.savingEquipamento}
        onClose={() =>
          viewModel.handleDeleteDiarioEquipamentoModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaDiarioEquipamento}
      />
      <DeleteDialog
        open={viewModel.diarioObraAtividadesDeleteModal}
        saving={viewModel.savingAtividades}
        onClose={() =>
          viewModel.handleDeleteDiarioAtividadesModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaDiarioAtividades}
      />
      <DeleteDialog
        open={viewModel.diarioObraParalisacoesDeleteModal}
        saving={viewModel.savingParalisacoes}
        onClose={() =>
          viewModel.handleDeleteDiarioParalisacoesModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaDiarioParalisacoes}
      />
      <DeleteDialog
        open={viewModel.diarioObraImagensDeleteModal}
        saving={viewModel.savingImagens}
        onClose={() =>
          viewModel.handleDeleteDiarioImagensModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaDiarioImagens}
      />
    </>
  );
};
